import { Button, Center, Text, VStack } from '@chakra-ui/react';

import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface NoAssignmentsPlaceholderProps {
  renderLink?: boolean;
}

export default function NoAssignmentsPlaceholder({
  renderLink = false,
}: NoAssignmentsPlaceholderProps) {
  const { t } = useTranslation();
  // Animation variants for fade-in
  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.div initial="hidden" animate="visible" variants={fadeInVariants}>
      <Center
        backgroundColor="warmNeutral.0"
        paddingY={10}
        borderRadius="16px"
        backgroundImage="url('/public/images/Assignment-Empty-Background.png')"
        backgroundSize="cover"
        backgroundPosition="center -45px"
      >
        <VStack>
          <VStack spacing={0}>
            <Text fontSize="22px" fontWeight={600} color="baseBlack">
              {t('learners.dashboard.greatJob')}
            </Text>

            <Text fontSize="14px" fontWeight={600} color="neutral.1000">
              {t('learners.dashboard.noAssignmentsDue')}
            </Text>
          </VStack>

          {renderLink && (
            <Button
              as={RouterLink}
              to="/explore"
              fontSize="14px"
              fontWeight={600}
              color="neutral.1000"
              textDecoration="underline"
              variant="link"
              _hover={{
                color: 'neutral.1000',
                textDecoration: 'underline',
              }}
            >
              {t('learners.dashboard.exploreMoreContent')}
            </Button>
          )}
        </VStack>
      </Center>
    </motion.div>
  );
}
